import { supabase } from '../lib/supabase';

export async function activateTrial(userId: string): Promise<void> {
  const { error } = await supabase.rpc('activate_trial', { user_id: userId });
  if (error) throw error;
}
